import { Row, Col, Form, Button, Card, InputGroup } from 'react-bootstrap'
import { PartnerAuthRequest } from '../../redux/slices/auth.slice'
import ButtonSpinner from '../../components/common/ButtonSpinner'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Images from '../../assets/js/images'
import { Fragment, useState } from 'react'
import { FiMail } from "react-icons/fi"

function PartnerLogin() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const { data: auth, loading } = useSelector(state => state.AuthSlice)
    // eslint-disable-next-line

    const handleSubmit = (e) => {
        e.preventDefault()
        const form = new FormData(e.target)
        const formData = Object.fromEntries(form)
        dispatch(PartnerAuthRequest({ data: formData, navigate }))
    }

    return (
        <Fragment>
            <div className="wrapper">
                {/* <div className="authentication-header"></div> */}
                <div className="section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0">
                    <div className="container">
                        <Row className='align-items-center'>
                            <Col md={6} className='text-center'>
                                <img src={Images?.NewLogo} alt="logo icon" style={{ width: '200px' }} className='mx-auto' />
                                <div style={{ backgroundImage: `url(${Images?.BgLogin})`, backgroundSize: 'cover' }} className='text-center'>
                                    <div style={{ minHeight: '450px' }} className='position-relative'>
                                        <img src={Images?.Car} className='position-absolute start-0' style={{ bottom: '70px', width: '500px' }} />
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <Row>
                                    <Col sm={10} md={8} className='mx-auto'>
                                        <Card className="card login-box">
                                            <div className="card-body">
                                                <div className="p-4 rounded">
                                                    <div className="text-center">
                                                        <h5 className="mb-4">{t('partner_login')}</h5>
                                                    </div>
                                                    <div className="form-body">
                                                        <Form className="row g-3" onSubmit={handleSubmit}>
                                                            <InputGroup className="mb-3">
                                                                <InputGroup.Text><FiMail /></InputGroup.Text>
                                                                <Form.Control type="email" name="email" id="inputEmailAddress" placeholder={t('enter_email')} />
                                                            </InputGroup>
                                                            <InputGroup className="input-group mb-3" id="show_hide_password">
                                                                <InputGroup.Text className='text-decoration-underline align-items-center'>***</InputGroup.Text>
                                                                <Form.Control type={showPassword ? 'text' : 'password'} name="password" className="border-end-0" id="inputChoosePassword" placeholder={t('enter_password')} /> <a type="button" onClick={() => { setShowPassword(!showPassword) }} className="input-group-text bg-transparent" style={{ top: '9px', right: '10px', zIndex: 99 }}>{showPassword ? <i className='bx bx-show'></i> : <i className='bx bx-hide'></i>}</a>
                                                            </InputGroup>
                                                            <Col md={12} className="text-end">	<Link to="/forgot-password">Forgot Password ?</Link>
                                                            </Col>
                                                            <Col className="col-12">
                                                                <div className="d-grid">
                                                                    <Button type="submit" className="btn btn-primary d-flex align-items-center justify-content-center">{t('login')} {loading && <ButtonSpinner />}</Button>
                                                                </div>
                                                            </Col>
                                                        </Form>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>

                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default PartnerLogin
